export const INSERIR_DADOS_ACESSO = "app/login/redux/INSERIR_DADOS_ACESSO";
export const LIMPAR_DADOS_ACESSO = "app/login/redux/LIMPAR_DADOS_ACESSO";
export const EXPIRAR_SESSAO = "app/login/redux/EXPIRAR_SESSAO";
export const ATUALIZAR_VALIDACAO_LOGIN = "app/login/redux/ATUALIZAR_VALIDACAO_LOGIN";
export const ATUALIZAR_USUARIO_AUTENTICADO = "app/login/redux/ATUALIZAR_USUARIO_AUTENTICADO";

const atualizarDadosAcesso = (dadosAcesso) => {
    return {
        type: INSERIR_DADOS_ACESSO,
        payload: { ...dadosAcesso },
    };
};

const limparDadosAcesso = () => {
    return {
        type: LIMPAR_DADOS_ACESSO,
    };
};

const expirarSessao = (tempoRenovarSessao) => {
    return {
        type: EXPIRAR_SESSAO,
        payload: tempoRenovarSessao,
    };
};

export { atualizarDadosAcesso, limparDadosAcesso, expirarSessao };